var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Es ist ein Fehler aufgetreten.")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.toHome}},[_vm._v(" Zur Startseite ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }